// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

// Components Imports
import OutlineItem from "./OutlineItem";

// Internal Imports
import { DOCUMENTS } from "../../../constants";
import { DOCUMENTVIEW_MODE } from "../constants";

// Destructing
const { DOCUMENT_MODE, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { DOCUMENTVIEW, FORMVIEW } = DOCUMENTVIEW_MODE;

class OutlineItems extends Component {
  state = {
    draggedOverID: null,
    draggedSection: null,
  };

  /**
   * Note :: All drag and drop related method have been commented out for now, but need those in future
   */
  // _onDrag = event => {
  //   event.preventDefault();
  // };

  // _onDragStart = (event, itemID, label) => {
  //   // this is required so that the dragged component could be moved
  //   event.dataTransfer.effectAllowed = "move";
  //   this.setState({ draggedSection: { id: itemID, label } });
  // };

  // _onDragOver = (event, itemID) => {
  //   event.preventDefault();
  //   if (this.state.draggedOverID !== itemID) {
  //     this.setState({ draggedOverID: itemID });
  //   }
  // };

  // _onDragEnd = event => {
  //   event.preventDefault();
  //   this.setState({ draggedSection: null, draggedOverID: null });
  // };

  // _onDragEnter = (event, itemID) => {
  //   event.preventDefault();
  //   if (this.state.draggedOverID !== itemID) {
  //     this.setState({ draggedOverID: itemID });
  //   }
  // };

  // _onDragLeave = event => {
  //   event.preventDefault();
  //   if (
  //     typeof event.target.className === "string" &&
  //     event.target.className.startsWith("document-headers-list")
  //   ) {
  //     this.setState({ draggedOverID: null });
  //   }
  // };

  // _onDrop = (event, itemID) => {
  //   event.preventDefault();
  //   const { headerList } = this.props;
  //   if (!this.state.draggedSection) {
  //     console.debug("No section dragged");
  //     return;
  //   }
  //   const {
  //     draggedSection: { id: draggedSectionID },
  //     draggedOverID,
  //   } = this.state;
  //   if (draggedSectionID === draggedOverID) {
  //     // if section and drop have same section , return null(prevent from deletion)
  //     return;
  //   }
  //   const updatedSectionList = headerList.filter(
  //     sectionID => draggedSectionID !== sectionID,
  //   );
  //   if (itemID === 0) {
  //     updatedSectionList.splice(0, 0, draggedSectionID);
  //   } else {
  //     const dropIndex = updatedSectionList.findIndex(
  //       sectionID => sectionID === itemID,
  //     );
  //     if (dropIndex !== -1) {
  //       updatedSectionList.splice(dropIndex + 1, 0, draggedSectionID);
  //     }
  //   }
  //   let newUpdatedSection = [];
  //   updatedSectionList.map(item => {
  //     if (item.split(":").length > 1) {
  //       if (item.split(":")[0] === "header") {
  //         newUpdatedSection = [...newUpdatedSection, item.split(":")[1]];
  //       }
  //     } else {
  //       newUpdatedSection = [...newUpdatedSection, item];
  //     }
  //     return newUpdatedSection;
  //   });
  //   this.props.reorderOutlineItemList(newUpdatedSection, headerList);
  //   this.setState({
  //     draggedOverID: null,
  //     draggedSection: null,
  //   });
  // };

  _getOutlineList = () => {
    let outlineList = [];

    // Get the outlineList for FROM VIEW
    if (this.props.currentView === FORMVIEW) {
      if (Array.isArray(this.props.docForm) && this.props.docForm.length > 0) {
        outlineList = this.props.docForm.map(({ id, label }, index) => ({
          id,
          label: `${index + 1}. ${label}`,
          type: "FORM_FIELDS",
          allowEdit: false,
        }));
      }
    }
    // Get the outlineList for DOCUMENT VIEW
    else if (this.props.currentView === DOCUMENTVIEW) {
      let coverpageBlock = [];
      let headerBlock = [];
      let footerBlock = [];
      const bodyBlock = [];

      // CoverPage View outline items :: check if coverpage is visible and
      // has a coverpage component
      // if (this.props.coverpageIsVisible) {
      if (this.props.coverpageIsVisible) {
        const coverpageID = Object.keys(this.props.components).find(
          item =>
            this.props.components[item].content &&
            this.props.components[item].content.type ===
              DOCUMENT_COMPONENT_TYPES.COVERPAGE,
        );
        coverpageBlock = coverpageID
          ? [{ id: coverpageID, type: DOCUMENT_COMPONENT_TYPES.COVERPAGE }]
          : [];
      }
      // Header/Footer View outline items :: check if header & footer is visible and
      // has a hoder&footer component
      if (this.props.headerfooterIsVisible) {
        const headerFooterID = Object.keys(this.props.components).find(
          item =>
            this.props.components[item].content &&
            this.props.components[item].content.type ===
              DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER,
        );
        if (headerFooterID) {
          headerBlock = [
            { id: headerFooterID, type: DOCUMENT_COMPONENT_TYPES.HEADER },
          ];
          footerBlock = [
            { id: headerFooterID, type: DOCUMENT_COMPONENT_TYPES.FOOTER },
          ];
        }
      }

      // Body View outline items
      this.props.layout.forEach(
        docRow =>
          Array.isArray(docRow) &&
          docRow.forEach(compotentId => {
            const componentData = this.props.components[compotentId];
            if (componentData && componentData.content) {
              const item = componentData.content;
              if (
                item.type !== DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER &&
                item.type !== DOCUMENT_COMPONENT_TYPES.COVERPAGE &&
                item.type !== DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER
              ) {
                bodyBlock.push({ id: item.id, type: "BODY" });
              }
            }
          }),
      );

      outlineList = [
        ...coverpageBlock,
        ...headerBlock,
        ...bodyBlock,
        ...footerBlock,
      ];
    }
    return outlineList;
  };

  render() {
    const { draggedSection, draggedOverID } = this.state;
    const lockDragnDrop = this.props.isLocked;
    // const lockDragnDrop = !!(this.props.isLocked || draggedSection !== null);
    // Get the valid class name
    let className = `document-headers-list ${this.props.mode.toLowerCase()}-headers `;
    if (
      this.props.isLocked ||
      (this.props.mode === "DOCUMENT" && this.props.isTemplateTypeForm)
    ) {
      className += " locked-headers";
    }
    const isDocumentView = this.props.currentView === DOCUMENT_MODE.DOCUMENT;

    const outlineItemList = this._getOutlineList();

    return (
      <div data-test="document-leftbar-wrapper" className="outline-wrapper">
        <span
          data-test="documentheader-quotation-leftbar-title"
          className={`quotation-leftbar-title ${
            this.props.isSharedDocument
              ? "shareddocument-quotation-leftbar-title"
              : ""
          }`}>
          Outline
        </span>
        <div className={className}>
          <div className="outline-scroll">
            <ul
              className="component-list"
              data-test="documentheader-component-list">
              {/* First dummy outline item placeholder to show the replica of dragged outline item */}
              {isDocumentView && (
                <li key="hidden-header-item">
                  <div className="header-item">
                    <div
                      className="component-item-dummy"
                      // onDragEnter={
                      //   !lockDragnDrop
                      //     ? event => this._onDragEnter(event, 0)
                      //     : undefined
                      // }
                      // onDragOver={
                      //   !lockDragnDrop
                      //     ? event => this._onDragOver(event, 0)
                      //     : undefined
                      // }
                      // onDrop={
                      //   !lockDragnDrop
                      //     ? event => this._onDrop(event, 0)
                      //     : undefined
                      // }
                      // onDragLeave={
                      //   !lockDragnDrop
                      //     ? event => event.stopPropagation()
                      //     : undefined
                      // }
                    />
                  </div>
                </li>
              )}
              {/* Replica of dragged outline item */}
              {/* {isDocumentView && draggedOverID === 0 && draggedSection && (
                <li key={`dragged-${draggedSection.id}`}>
                  <div className="drop-section">
                    <div
                      className="component-item"
                      onDragOver={
                        !lockDragnDrop
                          ? event => this._onDragOver(event, 0)
                          : undefined
                      }
                      onDrop={
                        !lockDragnDrop
                          ? event => this._onDrop(event, 0)
                          : undefined
                      }>
                      <div>
                        <i>
                          <FontAwesomeIcon icon={["far", "bars"]} />
                        </i>
                      </div>
                      <input
                        className="item-header"
                        value={draggedSection.label}
                        readOnly
                      />
                    </div>
                  </div>
                </li>
              )} */}
              {Array.isArray(outlineItemList) &&
                outlineItemList.length > 0 &&
                outlineItemList.map((outlineItem, index) => (
                  <OutlineItem
                    key={outlineItem.id}
                    {...this.props}
                    seqNo={index + 1}
                    item={outlineItem}
                    isDocumentView={isDocumentView}
                    isDocumentFormView={this.props.currentView === FORMVIEW}
                    lockDragnDrop={lockDragnDrop}
                    // handleEdit={this.props.handleEdit}
                    editable={this.props.editable}
                    updateOutlineLabel={this.props.updateOutlineLabel}
                    isSharedDocument={this.props.isSharedDocument}
                    // Drag & Drop related props
                    onDrag={this._onDrag}
                    onDragStart={this._onDragStart}
                    onDragEnd={this._onDragEnd}
                    onDragOver={this._onDragOver}
                    onDragEnter={this._onDragEnter}
                    onDragLeave={this._onDragLeave}
                    onDrop={this._onDrop}
                    draggedSection={draggedSection}
                    draggedOver={
                      draggedOverID === outlineItem.id && draggedSection
                        ? draggedSection.id !== outlineItem.id
                        : false
                    }
                  />
                ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

OutlineItems.propTypes = {
  editable: PropTypes.bool.isRequired,
  className: PropTypes.string, // to apply certain class name if required
  allowRearrange: PropTypes.bool,
  isSharedDocument: PropTypes.bool,
};

OutlineItems.defaultProps = {
  className: "",
  allowRearrange: false,
  isSharedDocument: false,
};

const mapStateToProps = state => {
  const { components, layout } = state.DocumentStore;
  return { components, layout };
};

export default connect(mapStateToProps)(OutlineItems);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/Outline/OutlineItems.js